import "@/App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PlasticCreditsSection from "./components/PlasticCreditsSection";
import ProcessSection from "./components/ProcessSection";
import ValueSection from "./components/ValueSection";
import BenefitsSection from "./components/BenefitsSection";
import TeamSection from "./components/TeamSection";
import BookingSection from "./components/BookingSection";
import CTAStrip from "./components/CTAStrip";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-[#0B1E2E]">
        {/* Noise overlay for texture */}
        <div className="noise-overlay" />

        <Navbar />
        <main>
          <HeroSection />
          <AboutSection />
          <CTAStrip variant="default" />
          <PlasticCreditsSection />
          <ProcessSection />
          <CTAStrip variant="bold" />
          <ValueSection />
          <BenefitsSection />
          <BookingSection />
          <TeamSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
